<div class="backgroundImagePanel">
    @if(secondImage )
    {   
        <img  id="backgroundImageSecond" class="backgroundImageLocal" [src]="secondImage" alt="">
    }
    @if(firstImage){
        <img  id="backgroundImageFirst" class="backgroundImageLocal" [@leave]="animationStateOut" [src]="firstImage" alt="" (@leave.done)="animOutDone()">
    }
    <div  id="backgroundColor" class="backgroundImageLocal" [style.background-color]="color"></div>
</div>
